function scrollTo(section) {
    if (section === "response") {
        // Remove loading animation
        document.querySelector('.loading-validator').classList.remove('d-block');
        document.querySelector('.upload-box-input').classList.remove('d-none');
        document.querySelector('.upload-box').classList.remove('is-loading');
        document.querySelector('.upload-box').classList.add('is-success');

        // Go to validated result
        const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    } else if (section === "top") {
        window.scroll({ top: 0, behavior: 'smooth' });
    }
}

ko.bindingHandlers.fileUpload = {
    init: function(element, valueAccessor) {
        element.addEventListener('change', () => valueAccessor()(element.files[0]));
        element.addEventListener('click', (event) => event.target.value = null);
    },
    update: function(element, valueAccessor) {
        if (ko.unwrap(valueAccessor()) === null) {
            const form = document.createElement('form');
            element.parentNode.insertBefore(form, element);
            form.appendChild(element);
            form.reset();

            form.parentNode.insertBefore(element, form);
            form.remove();
        }
    }
};

var VM = function () {
    var self = this;

    self.showResult = ko.observable(false);
    self.input = ko.observable('');
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });
    self.status = ko.observable();

    self.results = ko.observableArray([]);

    self.options = { lineNumbers: true };
    self.allowSetValue = ko.observable(false);
    self.error = ko.observable('');
    self.errorLine = ko.observable();

    self.errorSize = ko.observable('');
    self.inputFile = ko.observable('');
    self.uploadFile = ko.observable(null);
    self.fileName = ko.pureComputed(function(){
        if (self.uploadFile()) {
            return self.uploadFile().name;
        }
    });

    // Validate & Format button
    self.validate = function (e, upload) {
        let theData = null;
        self.status("");

        if (!upload) {
            // Show loading animation
            document.querySelector('.loading-validator').classList.add('d-block');
            self.inputFile('');
            self.uploadFile('');

            const form = document.getElementById('validateMe');
            formData = new FormData(form);
            theData = new URLSearchParams(formData).toString();
        } else {
            self.input('');
            theData = new URLSearchParams({ "content": upload });
        }

        fetch("/tools/w3c-extended-log-file-format-viewer/", {
            method: 'POST',
            headers: {
                '__RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value'),
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: theData
        })
        .then(response => response.json())
        .then(response => {
            const content = response;

            if (content) {
                self.results(content);
                self.error("");
                self.showResult(true);
            }

            if (!upload) {
                // Remove loading animation
                document.querySelector('.loading-validator').classList.remove('d-block');
            } else {
                document.querySelector('.upload-box-input').classList.remove('d-none');
                document.querySelector('.upload-box').classList.remove('is-loading')
                document.querySelector('.upload-box').classList.add('is-success');
            }

            // Go to validated result
            const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        })
        .catch(error => {
            self.status("Invalid log");
            self.results("");
            self.error("Error during parsing");
            self.showResult(true);
            document.querySelector('.upload-box-input').classList.remove('d-none');
            document.querySelector('.upload-box').classList.remove('is-loading');
            // Remove loading animation
            document.querySelector('.loading-validator').classList.remove('d-block');
            // Go to validated result
            const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
            window.scroll({ top: targetPosition, behavior: 'smooth' });
        });
    }

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });

    // drag & drop
    self.formDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.add('is-dragover');
    };
    self.formNotDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.remove('is-dragover');
    };
    self.formDrop = function(data, event) {
        self.uploadFile(event.originalEvent.dataTransfer.files[0]);
        self.readUploadedFile();
    };

    // Read File
    self.readUploadedFile = function() {
        if (self.uploadFile()) {
            var regex = /(.*?)\.(log)$/;

            document.querySelector('.upload-box').classList.remove('is-success', 'is-error', 'is-error-type', 'is-error-size');
            document.querySelector('.upload-box-input').classList.add('d-none');
            document.querySelector('.upload-box').classList.add('is-loading');

            if (self.uploadFile().type !== "" && !regex.test(self.uploadFile().name)) {
                setTimeout(function() {
                    document.querySelector('.upload-box-input').classList.remove('d-none');
                    document.querySelector('.upload-box').classList.remove('is-loading');
                    document.querySelector('.upload-box').classList.add('is-error', 'is-error-type');
                }, 500);
                return false;
            } else {
                if (self.uploadFile().size > 1048576 || self.uploadFile().size === 0) {
                    if (self.uploadFile().size > 1048576) {
                        self.errorSize("Error: Uploaded file size can not exceed 1 MB !");
                    } else {
                        self.errorSize("Error: Uploaded file is empty !");
                    }
                    setTimeout(function() {
                        document.querySelector('.upload-box-input').classList.remove('d-none');
                        document.querySelector('.upload-box').classList.remove('is-loading')
                        document.querySelector('.upload-box').classList.add('is-error', 'is-error-size');
                    }, 500);
                    return false;
                } else {
                    var reader = new FileReader();
                    reader.onloadend = function(e) {
                        var fileDataText = reader.result;
                        displayResult(fileDataText);
                    };
                    reader.readAsText(self.uploadFile());
                    return true;
                }
            }
        }
    }

    function displayResult(fileDataText) {
        self.inputFile(fileDataText);
        self.validate(null, self.inputFile());
    }
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});